import React from 'react'
import PropTypes from 'prop-types'
import Form from '../components/Form'

export const ContactPageTemplate = ({ title, html }) => {
  return (
    <main id="main" className="site-main">
      <div className="hero hero-subpage strong-overlay">
        <div className="hero-content text-center">
          <div className="container">
            <h1 className="h-80 weight-bold">{title}</h1>
            <p className="p-24">Feel free to contact us.</p>
          </div>
        </div>
        <div
          className="contact-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />

        <section className="section-contact-us">
          <div className="container container-1010">
            <Form />
          </div>
        </section>
      </div>
    </main>
  )
}

ContactPageTemplate.propTypes = {
  title: PropTypes.string.isRequired
}

const ContactPage = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;

  return (
    <ContactPageTemplate
      html={html}
      title={frontmatter.title}
    />
  )
}

ContactPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ContactPage

export const contactPageQuery = graphql`
  query ContactPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/contact-page.js